export default __webpack_public_path__ + "static/media/type_16_5.cccaa9d0.svg";